import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        minHeight: 'auto',
        py: 2,
        px: open ? 2 : 1,
        position: 'relative',
        borderBottom: 0,
        bgcolor: '#ffffff',
        overflow: 'visible',
        zIndex: 2
      }}
    >
      <Box sx={{ position: 'relative', width: '100%', minHeight: open ? 44 : 36, overflow: 'visible' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            maxWidth: '100%',
            minHeight: open ? 44 : 36,
            overflow: 'hidden',
            alignItems: 'center'
          }}
        >
          <Logo isIcon={!open} sx={{ width: open ? 'auto' : 36, height: open ? undefined : 36, px: 0, py: 0, mt: 0 }} />
        </Box>
      </Box>
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
